import styled from 'styled-components';

export const SignInUpContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
`;

export const SignInUpFormContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 10px 35px -20px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  min-height: 380px;
  display: flex;
  align-items: center;
`;
